import { useState, useCallback } from "react";

const CHAT_WEBHOOK_URL ="https://automation.pragpms.com/webhook/63dd5f2f-5f5f-4c86-bfdc-2fb8cfc1be56"
  // "https://automation.pragpms.com/webhook/63dd5f2f-5f5f-4c86-bfdc-2fb8cfc1be56";

export function useChat() {
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [sessionId] = useState(
    () =>
      `session_${Date.now()}_${Math.random()
        .toString(36)
        .substr(2, 9)}`
  );
  const sendMessage = useCallback(
    async (content) => {
      setIsLoading(true);

      try {
        if (content.trim() !== "") {
          const userMessage = {
            id: `msg_${Date.now()}_user`,
            content,
            isUser: true,
            timestamp: new Date(),
          };

          setMessages((prev) => [...prev, userMessage]);
        }
        const response = await fetch(CHAT_WEBHOOK_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            sessionId,
            chatInput: content || "",
          }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        console.log(response,"response ai chatbot")
        const data = await response.json();
        console.log(data,"response data")
        const botReply = String(
          data.reply ||
            data.outputText ||
            data.output ||
            data.message ||
            data.response ||
            "No response from server"
        );

        const botMessage = {
          id: `msg_${Date.now()}_bot`,
          content: botReply,
          isUser: false,
          timestamp: new Date(),
        };

        setMessages((prev) => [...prev, botMessage]);

      } catch (error) {
        console.error("Chat error:", error);

        const errorMessage = {
          id: `msg_${Date.now()}_error`,
          content:
            "Sorry, I'm having trouble connecting right now. Please try again later.",
          isUser: false,
          timestamp: new Date(),
        };
        setMessages((prev) => [...prev, errorMessage]);
      } finally {
        setIsLoading(false);
      }
    },
    [sessionId]
  );

  const clearChat = useCallback(() => {
    setMessages([]);
  }, []);

  return {
    messages,
    isLoading,
    sendMessage,
    clearChat,
    sessionId,
  };
}